import React from "react";
import { Link, useLocation } from "react-router";
import {
	Sidebar,
	SidebarContent,
	SidebarGroup,
	SidebarGroupLabel,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuItem,
	SidebarMenuButton,
	SidebarHeader,
	SidebarFooter,
} from "@acme/ui/sidebar";
import {
	Home,
	Users,
	Settings,
	GalleryVerticalEnd,
	AudioWaveform,
	Command,
	Folder,
} from "lucide-react";
import { TeamSwitcher } from "./TeamSwitcher";
import { NavUser } from "./NavUser";
import { authClient } from "@/context/authClient";

export function DashboardSidebar() {
	const { pathname } = useLocation();

	const { data } = authClient.useSession();
	return (
		<Sidebar side="left" variant="sidebar" collapsible="none">
			<SidebarHeader>
				<TeamSwitcher
					teams={[
						{
							name: "Acme Inc",
							logo: GalleryVerticalEnd,
							plan: "Enterprise",
						},
						{
							name: "Acme Corp.",
							logo: AudioWaveform,
							plan: "Startup",
						},
						{
							name: "Evil Corp.",
							logo: Command,
							plan: "Free",
						},
					]}
				/>
			</SidebarHeader>
			<SidebarContent>
				<SidebarGroup>
					<SidebarGroupLabel>Admin Menu</SidebarGroupLabel>
					<SidebarGroupContent>
						<SidebarMenu>
							<SidebarMenuItem>
								<SidebarMenuButton asChild>
									<Link
										to="/dashboard"
										className={
											pathname === "/dashboard" ? "bg-gray-200 text-black" : ""
										}
									>
										<Home className="mr-2" />
										<span>Dashboard</span>
									</Link>
								</SidebarMenuButton>
							</SidebarMenuItem>
							<SidebarMenuItem>
								<SidebarMenuButton asChild>
									<Link
										to="/dashboard/users"
										className={
											pathname === "/dashboard/users"
												? "bg-gray-200 text-black"
												: ""
										}
									>
										<Users className="mr-2" />
										<span>Users</span>
									</Link>
								</SidebarMenuButton>
							</SidebarMenuItem>
							<SidebarMenuItem>
								<SidebarMenuButton asChild>
									<Link
										to="/dashboard/live-sessions"
										className={
											pathname === "/dashboard/live-sessions"
												? "bg-gray-200 text-black"
												: ""
										}
									>
										<AudioWaveform className="mr-2" />
										<span>Live Sessions</span>
									</Link>
								</SidebarMenuButton>
							</SidebarMenuItem>

							<SidebarMenuItem>
								<SidebarMenuButton asChild>
									<Link
										to="/dashboard/templates"
										className={
											pathname === "/dashboard/templates"
												? "bg-gray-200 text-black"
												: ""
										}
									>
										<Folder className="mr-2" />
										<span>Templates</span>
									</Link>
								</SidebarMenuButton>
							</SidebarMenuItem>

							<SidebarMenuItem>
								<SidebarMenuButton asChild>
									<Link
										to="/dashboard/assignments"
										className={
											pathname === "/dashboard/assignments"
												? "bg-gray-200 text-black"
												: ""
										}
									>
										<Command className="mr-2" />
										<span>Assignments</span>
									</Link>
								</SidebarMenuButton>
							</SidebarMenuItem>
						</SidebarMenu>
					</SidebarGroupContent>
				</SidebarGroup>
			</SidebarContent>
			<SidebarFooter>
				{data?.user && (
					<NavUser
						user={{
							name: data.user.name,
							email: data.user.email,
							avatar: data.user.image ?? "",
						}}
					/>
				)}
			</SidebarFooter>
		</Sidebar>
	);
}
